import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { DefaultTranspiler, provideTransloco, provideTranslocoLoader, TRANSLOCO_TRANSPILER } from '@jsverse/transloco';
import { AuthModule } from 'app/core/auth/auth.module';
import { IconsModule } from 'app/core/icons/icons.module';
import { TranslocoCoreModule } from 'app/core/transloco/transloco.module';
import { environment } from 'environments/environment';
import { TranslocoHttpLoader } from './transloco/transloco.http-loader';
import { FuseSplashScreenService } from '@fuse/services/splash-screen/splash-screen.service';

export function initSplashScreen(splashService: FuseSplashScreenService) {
  return () => {
    // No-op — just ensures the service is instantiated
  };
}

@NgModule({
  imports: [
    AuthModule,
    IconsModule,
    TranslocoCoreModule
  ],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: environment.production
      }
    }),
    provideTranslocoLoader(TranslocoHttpLoader),
    {
      provide: TRANSLOCO_TRANSPILER,
      useClass: DefaultTranspiler
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initSplashScreen,
      deps: [FuseSplashScreenService],
      multi: true
    }
  ]
})
export class CoreModule {
  /**
   * Constructor
   */
  constructor(
    @Optional() @SkipSelf() parentModule?: CoreModule
  ) {
    // Do not allow multiple injections
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
    }
  }
}
